import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

function GlassEffectHeaderLayout({darkText= false,seoPage}) {
  return (
    <>
      <Header seoPage={seoPage} glassEffect={true} darkText={darkText} />
      <main id="main-content" role="main">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

export default GlassEffectHeaderLayout;
